import { message } from "ant-design-vue";
import eventBus from "@/src/utils/eventBus.js";
import ProjectService from "@/src/api/ProjectService.js";

export const MAX_SLUG_LENGTH = 90;

export const generateSlugFromName = (name) => {
  if (!name) return "";
  let slug = name.trim().toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
  if (slug.length > MAX_SLUG_LENGTH) slug = slug.substring(0, MAX_SLUG_LENGTH).replace(/_+$/, "");
  return slug;
};

export const buildNoteSlugId = (note) => {
  if (!note?.id) return "";
  const slug = note.slug || generateSlugFromName(note.name);
  return slug ? `${slug}-${note.id}` : note.id;
};

export const parseNoteIdFromSlug = (slugId) => {
  if (!slugId) return null;
  const match = slugId.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i);
  return match ? match[0] : slugId;
};

export const noteEvents = {
  CREATED: "created",
  UPDATED: "updated",
  DELETED: "deleted",
};

export const EMPTY_QUILL_PATTERN = /<p>(<br>)?<\/p>/g;

export const hasNoteContent = (domParser, html) => {
  if (!html || !domParser) return false;
  const doc = domParser.parseFromString(html, "text/html");
  return doc.body.innerHTML.replace(EMPTY_QUILL_PATTERN, "").trim() !== "";
};

export const hasNoteAttachments = (attachments) => {
  return attachments?.length > 0;
};
export const renameNote = async (noteId, newName, spaceId) => {
  const response = await ProjectService.notes.updateNote(noteId, {
    name: newName,
  });
  if (response?.success) {
    message.success(`Note renamed to ${newName} successfully!`);
    eventBus.emit("note-manipulated", { event: noteEvents.UPDATED, spaceId: spaceId || null });
    eventBus.emit("note-title-updated", { noteId, name: newName });
  }
  return response;
};

export const findNotePath = (nodes, targetId, path = []) => {
  for (const node of nodes) {
    const current = [...path, node];
    if (String(node.id) === String(targetId)) return current;
    if (node.children?.length) {
      const found = findNotePath(node.children, targetId, current);
      if (found) return found;
    }
  }
  return null;
};

export const buildNoteTree = (flatNotes) => {
  const map = {};
  flatNotes.forEach((n) => { map[n.id] = { ...n, children: [] }; });
  const roots = [];
  flatNotes.forEach((n) => {
    if (n.parent_id && map[n.parent_id]) {
      map[n.parent_id].children.push(map[n.id]);
    } else {
      roots.push(map[n.id]);
    }
  });
  return roots;
};

export const getNoteItemActions = (imageNames, handlers) => [
  {
    id: "more_options",
    title: "More options",
    icon: imageNames.MORE_ICON_GREY,
    size: 14,
    tooltip: true,
    options: [
      {
        id: "rename",
        title: "Rename",
        icon: imageNames.EDIT,
        size: 14,
        action: handlers.onRename,
      },
      {
        id: "delete",
        title: "Delete",
        icon: imageNames.DELETE_GREY,
        size: 14,
        action: handlers.onDelete,
      },
    ],
  },
];
